// Banner.js
import React from 'react';
import '../css/index2.css';
const AboutBanner = () => {
    
  return (
    <div class="about-me-header">
      
  <div class="text-content">
    <h1>between everything, anything!!!</h1>
    <p> <br />A natural leader with a proactive mindset. <br /> <br />
    I'm an introspective creative, always seeking to explore the deeper layers of emotion and experience. With my ability to combine contrasts and personify abstract feelings, 
    I create vivid and impactful stories that resonate on a personal level. <br /><br/>
    I find inspiration in the unthought-of. 
     </p>
  </div>
  <div class="image-content">
    <img src="images/me3.png" alt="About Me" />
  </div>
</div>

    
  );
};

export default AboutBanner;
